// eslint-disable-next-line deprecation/deprecation
export { InputBase, type InputBaseProps } from './InputBase';
import { inputBaseClasses as muiInputBaseClasses } from '@mui/material/InputBase';

/**
 * @deprecated Unsupported component: This is an internal component, use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const inputBaseClasses = muiInputBaseClasses;
export * from './inputBaseModuleAugmentation';
